"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Annotation = void 0;
/**
 * A  text note which also  contains information about who made the statement and when.
 */
var Annotation = /** @class */ (function () {
    function Annotation() {
    }
    return Annotation;
}());
exports.Annotation = Annotation;
